{
	"title": "Product allocation",
	"transactionTitle": "Transaction ({{totalCount}})"
}
